module.exports = __webpack_public_path__ + "img/html5.4c878bd1.svg";